<template>
  <div>
    <Boyo-Dialog :dialogInfo="dialogInfoData" @dialogEvent="dialogEventData">
      <div style="display: flex; flex-direction: row; align-items: flex-start;">
        <!-- 左侧竖向步骤条 -->
        <div style="width: 240px; min-width: 240px; margin-right: 24px;">
          <el-steps direction="vertical" :active="activeValue" class="custom-steps-vertical">
            <el-step
              v-for="(itemf, index) of activeList"
              :key="index"
              :title="itemf.processNodeName"
              :status="itemf.stepStatus || 'process'">
              <template slot="description">
                <div v-if="itemf.processNodeName === '制单人'">
                  {{ itemf.approvalTime }}
                </div>
                <div v-else>
                  <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                  <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                  <div>经办人：{{ itemf.maker || '' }}</div>
                  <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                  <div>时间：{{ itemf.makerTime || '' }}</div>
                </div>
              </template>
            </el-step>
          </el-steps>
        </div>

        <!-- 右侧内容 -->
        <div style="flex: 1; overflow-x: auto;">
          <Boyo-Formtwo
            :formInfo="formInfo"
            :refObj.sync="formInfo.ref"
            :listTypeInfo="listTypeInfo">
          </Boyo-Formtwo>

          <!-- 审核表单 -->
          <div v-if="showAuditForm" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
            <div class="quick-phrase-area">
              <div class="quick-phrase-label">常用快捷短语:</div>
              <div class="quick-phrase-buttons">
                <el-button
                  v-for="(phrase, index) in quickPhrases"
                  :key="index"
                  size="mini"
                  @click="insertQuickPhrase(phrase)"
                  class="phrase-btn">
                  {{ phrase }}
                </el-button>
              </div>
            </div>

            <Boyo-Formtwo
              :formInfo="auditFormInfo"
              :refObj.sync="auditFormInfo.ref"
              :listTypeInfo="listTypeInfo">
            </Boyo-Formtwo>
          </div>
        </div>
      </div>
    </Boyo-Dialog>
  </div>
</template>

<script>
import BoyoDialog from '@/components/BoyoDialog'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import config from '@/api/config'

export default {
  name: 'CustomerCreditLimitDialog',
  components: {
    BoyoDialog,
    BoyoFormtwo
  },
  data () {
    return {
      dataSourcesId: null,
      processInstanceId: null,
      createdBy: null,
      createdTime: null,
      activeValue: 0,
      activeList: [],
      pingImgUrl: config.pingImgUrl,
      quickPhrases: ['同意', '不同意', '需要补充相关附件', '信用额度'],
      detailLoading: false,
      processEnumLoading: false,
      listTypeInfo: {
        processId: [],
        statusFlag2: [{ value: 1, label: '同意' }, { value: 2, label: '不同意' }]
      },
      dialogInfoData: {
        visible: false,
        type: 'update',
        title: { update: '客户信用额度审批' },
        width: '1200px',
        btList: [
          { label: '审核', type: 'success', icon: '', event: 'save', loading: false, show: false },
          { label: '关闭', event: 'close', show: true }
        ]
      },
      // 详情表单
      formInfo: {
        ref: null,
        labelWidth: '110px',
        inline: true,
        data: {
          partnerName: '',
          befCreditLimit: '',
          afterCreditLimit: '',
          reason: ''
        },
        list: [
          { type: 'text', label: '客户：', value: 'partnerName', style: 'width:90%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '前信用额度：', value: 'befCreditLimit', style: 'width:90%', className: 'form_item_two', disabled: true },
          { type: 'textarea', label: '操作原因：', value: 'reason', style: 'width:90%', className: 'form_item_two', disabled: true },
          { type: 'text', label: '后信用额度：', value: 'afterCreditLimit', style: 'width:90%', className: 'form_item_two', disabled: true },
        ],
        rules: {}
      },
      auditParm: {},
      showAuditForm: false,
      auditFormInfo: {
        ref: null,
        labelWidth: '100px',
        data: {
          processId: '',
          status: 1,
          remark: ''
        },
        list: [
          { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%', disabled: true },
          { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one', list: 'statusFlag2', unclearable: true },
          { type: 'text', label: '备注：', value: 'remark', style: 'width:80%' }
        ],
        rules: {
          status: [{ required: true, trigger: 'change', message: '请选择' }]
        }
      }
    }
  },
  methods: {
    loadProcessEnum () {
      // 写法与其它弹窗统一：已加载则直接 resolve；未加载则请求枚举并映射
      return new Promise(resolve => {
        if (Array.isArray(this.listTypeInfo.processId) && this.listTypeInfo.processId.length > 0) {
          resolve()
          return
        }
        this.processEnumLoading = true
        this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
          if (res.code === 0) {
            const list1 = (res.data && Array.isArray(res.data.list)) ? res.data.list : []
            this.listTypeInfo.processId = list1.map(item => ({
              value: item.enumName,
              enumValue: item.enumValue,
              label: item.enumRemark
            }))
          } else {
            this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
          }
          resolve()
        }).catch(() => {
          this.$message({ message: '加载流程枚举失败', type: 'error' })
          resolve()
        }).finally(() => {
          this.processEnumLoading = false
        })
      })
    },
    // (dataSourcesId, auditDialog, auditParm, processInstanceId, maker, makerTime)
    async dialogShow (dataSourcesId, auditDialog, auditParm, processInstanceId, maker, makerTime) {
      this.dataSourcesId = dataSourcesId
      this.processInstanceId = processInstanceId
      this.createdBy = maker
      this.createdTime = makerTime
      // 打开弹窗前确保流程枚举已加载
      await this.loadProcessEnum()

      // 审核参数
      if (auditParm && auditParm.id) {
        this.auditParm = auditParm
        this.dialogInfoData.btList[0].show = true
        this.showAuditForm = true
        this.resetAuditForm()
        // 枚举已加载，直接回填流程名
        this.fillProcessNameFromEnum(auditParm.processId)
      } else {
        this.dialogInfoData.btList[0].show = false
        this.showAuditForm = false
      }

      this.loadDetailByDataSourcesId()
      this.loadApprovalSteps()
      this.dialogInfoData.visible = true
    },

    resetAuditForm () {
      for (const k in this.auditFormInfo.data) this.auditFormInfo.data[k] = ''
      this.auditFormInfo.data.status = 1
    },

    fillProcessNameFromEnum (processIdEnumValue) {
      let processFound = false
      for (const item of this.listTypeInfo.processId) {
        if (item.enumValue == processIdEnumValue) {
          this.auditFormInfo.data.processId = item.value
          processFound = true
          break
        }
      }
      if (!processFound) {
        this.auditFormInfo.data.processId = processIdEnumValue
      }
    },

    resetDetailForm () {
      this.formInfo.data.partnerName = ''
      this.formInfo.data.befCreditLimit = ''
      this.formInfo.data.afterCreditLimit = ''
      this.formInfo.data.reason = ''
    },

    loadDetailByDataSourcesId () {
      this.resetDetailForm()
      if (!this.dataSourcesId) return

      this.detailLoading = true
      // dataSourcesId = BASE_PARTNER_CREDIT_LIMIT.id
      // 详情（本次申请）在 LOG 表里：partnerCreditLimitId = dataSourcesId
      this.$api.Customer.getBasePartnerCreditLimitLogPage({
        id: this.dataSourcesId,
        pageNum: 1,
        pageSize: 1
      }).then(res => {
        if (res.code === 0 && res.data && Array.isArray(res.data.list) && res.data.list.length > 0) {
          const list = res.data.list

          // 优先找“待审核/未提交”状态的那条（0/1 兼容），找不到就取最新一条
          const pending = list.find(i => i.auditStatus === 1 || i.auditStatus === 0)
          const record = pending || list[0]

          this.formInfo.data.partnerName = record.partnerName || ''
          this.formInfo.data.befCreditLimit = record.befCreditLimit !== undefined ? record.befCreditLimit : ''
          this.formInfo.data.afterCreditLimit = record.afterCreditLimit !== undefined ? record.afterCreditLimit : ''
          this.formInfo.data.reason = record.reason || ''
        } else {
          this.$message({ message: '未查询到信用额度申请明细（请确认 dataSourcesId 是否正确）', type: 'warning' })
        }
      }).catch(() => {
        this.$message({ message: '查询信用额度申请明细失败', type: 'error' })
      }).finally(() => {
        this.detailLoading = false
      })
    },

    loadApprovalSteps () {
      if (!this.processInstanceId) return
      this.$api.system.getActProcessEntryPage({ idProcessInstance: this.processInstanceId, pageNum: 1, pageSize: 999 }).then(res => {
        if (res.code === 0) {
          this.activeList = []
          this.activeValue = 0
          const list = (res.data && res.data.list) ? res.data.list : []
          for (let i = 0; i < list.length; i++) {
            if (list[i].status && i < list.length) this.activeValue = Number(i) + 1
            let stepStatus = 'process'
            if (list[i].status === 1) stepStatus = 'success'
            else if (list[i].status === 2) stepStatus = 'error'
            this.activeList.push({
              processNodeName: list[i].processNodeName || '',
              maker: list[i].status ? list[i].actualApprover : (list[i].approver ? list[i].approver : list[i].roleName),
              remark: list[i].remark || '',
              makerTime: list[i].approvalTime || '',
              stepStatus
            })
          }
          const maker = this.createdBy || '暂无'
          const makerTime = this.createdTime || ''
          const approvalTime = maker + (makerTime ? (' ' + makerTime) : '')
          this.activeList.unshift({ processNodeName: '制单人', approvalTime })
          this.activeValue = (this.activeValue || 0) + 1
        }
      })
    },

    dialogEventData (event) {
      const dialogInfoData = this.dialogInfoData
      switch (event) {
        case 'save':
          this.auditFormInfo.ref.validate(valid => {
            if (!valid) return
            const payload = {
              id: this.auditParm.id,
              processId: this.auditFormInfo.data.processId,
              status: this.auditFormInfo.data.status,
              remark: this.auditFormInfo.data.remark
            }
            dialogInfoData.btList[0].loading = true
            this.$api.system.approval(payload).then(res => {
              dialogInfoData.btList[0].loading = false
              if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                dialogInfoData.visible = false
                this.showAuditForm = false
                this.$emit('approvalInfo')
              } else {
                this.$message({ message: res.msg, type: 'error' })
              }
            }).catch(() => {
              dialogInfoData.btList[0].loading = false
            })
          })
          break
        case 'close':
          dialogInfoData.visible = false
          this.showAuditForm = false
          break
      }
    },

    insertQuickPhrase (phrase) {
      const current = this.auditFormInfo.data.remark || ''
      this.auditFormInfo.data.remark = current ? (current + ' ' + phrase) : phrase
    }
  }
}
</script>

<style lang="stylus" scoped>
.custom-steps-vertical
  .el-step__description
    padding-left 10px

.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}
</style>




// WEBPACK FOOTER //
// src/components/Custom/CustomerCreditLimitDialog.vue